import { render } from "./VODSocialTab.vue?vue&type=template&id=1e0f8ef1"
import script from "./VODSocialTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODSocialTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODSocialTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e0f8ef1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e0f8ef1', __exports__)) {
    api.reload('1e0f8ef1', __exports__)
  }
  
  module.hot.accept("./VODSocialTab.vue?vue&type=template&id=1e0f8ef1", () => {
    api.rerender('1e0f8ef1', render)
  })

}


export default __exports__